export class TriggerKeyspacesScheduledDump200Response {
    'jobId';
    'workflowId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TriggerKeyspacesScheduledDump200Response.attributeTypeMap;
    }
    constructor() {
    }
}
